import { takeLatest, put, select } from 'redux-saga/effects';
import errorCatcher from '../utils/errorCatcher';
import { ACTIONS } from '../actions/actionTypes';
import { push } from 'react-router-redux';

import * as game from '../controllers';

function * GET_CURIOSITY () {
    yield takeLatest(ACTIONS.SET_CURIOSITY_SHOWED, function * (action) {
        try {
            console.log(action);
            let missions = yield select(state => state.missionReducer.missions);
            missions = missions.filter(mission => mission._id !== action.payload.curiosity._id);
            yield put({type: ACTIONS.SET_MISSIONS, payload: missions});
            game.curiosity.setCuriosityShowed(action.payload.curiosity._id);
        } catch (error) {
            errorCatcher(error);
            yield put(push('/'));
        }
    });
}

export { GET_CURIOSITY };



// WEBPACK FOOTER //
// ./src/sagas/curiositySaga.js